import { format, isValid } from 'date-fns'

export const DATE_FORMAT_API = 'dd-MMM-yyyy'
const DATE_TIMESTAMP_FORMAT_API = 'dd-MMM-yyyy HH:mm:ss'

// ==================================================================================================================
//  Date string conversions between formats
// ==================================================================================================================

export const formatDateStringAsApiFormat = (date?: string | null): string | null => {
  if (date === undefined) return null
  if (date === null) return null
  if (date === '') return ''

  const newDate = new Date(date)
  if (isValid(newDate)) {
    return format(newDate, DATE_FORMAT_API)
  } else {
    return date
  }
}

// ==================================================================================================================
//  Date object to formatted string
// ==================================================================================================================

export const formatDateAsApiFormat = (date?: Date | null): string | null => {
  if (date === undefined) return null
  if (date === null) return null
  return format(date, DATE_FORMAT_API)
}

export const formatDateTimeAsApiFormat = (date?: Date | null): string | null => {
  if (date === undefined) return null
  if (date === null) return null
  return format(date, DATE_TIMESTAMP_FORMAT_API)
}

// ==================================================================================================================
//  Validate the date format of a date as a string. Used by our Yup validation.
// ==================================================================================================================

export const validateDateFormatApi = (date?: string | null): boolean => {
  if (date === undefined) return true
  if (date === null) return true
  if (date === '') return true

  const parsedDate = new Date(date)
  return (isValid(parsedDate))
}
